/**
 * Fleet CC DCRP Recovery API
 * Connected Claims Damaged Container Recovery APIs used for handling recovery data.
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */

import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../../services/encoder';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { UploadFileType } from '../models/uploadFileType';

@Injectable()
export class BlobService {
  protected basePath = environment.ccdcrp_api_base_url;
  public defaultHeaders = new HttpHeaders();

  constructor(protected httpClient: HttpClient) {}

  /**
   * Downloads the blob content.
   *
   * @param uri uri path of the blob
   * @param aPIVersion
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public blobDownloadGet(
    uri: string,
    aPIVersion?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Blob>;
  public blobDownloadGet(
    uri: string,
    aPIVersion?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Blob>>;
  public blobDownloadGet(
    uri: string,
    aPIVersion?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Blob>>;
  public blobDownloadGet(
    uri: string,
    aPIVersion?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (uri === null || uri === undefined) {
      throw new Error(
        'Required parameter uri was null or undefined when calling blobDownloadGet.'
      );
    }

    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });
    if (uri !== undefined && uri !== null) {
      queryParameters = queryParameters.set('uri', <any>uri);
    }

    let headers = this.defaultHeaders;
    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    return this.httpClient.request('get', `${this.basePath}/blob/download`, {
      params: queryParameters,
      responseType: 'blob',
      headers: headers,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Validates and uploads a file to blob.
   *
   * @param fileType
   * @param destinationPath
   * @param file
   * @param aPIVersion
   * @param idToken ID Token for authentication
   * @param caseId
   * @param comments
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public blobUploadPostForm(
    fileType: UploadFileType,
    destinationPath: string,
    file?: Blob,
    aPIVersion?: string,
    idToken?: string,
    caseId?: number,
    comments?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<number>;
  public blobUploadPostForm(
    fileType: UploadFileType,
    destinationPath: string,
    file?: Blob,
    aPIVersion?: string,
    idToken?: string,
    caseId?: number,
    comments?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<number>>;
  public blobUploadPostForm(
    fileType: UploadFileType,
    destinationPath: string,
    file?: Blob,
    aPIVersion?: string,
    idToken?: string,
    caseId?: number,
    comments?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<number>>;
  public blobUploadPostForm(
    fileType: UploadFileType,
    destinationPath: string,
    file?: Blob,
    aPIVersion?: string,
    idToken?: string,
    caseId?: number,
    comments?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (fileType === null || fileType === undefined) {
      throw new Error(
        'Required parameter fileType was null or undefined when calling blobUploadPost.'
      );
    }

    if (destinationPath === null || destinationPath === undefined) {
      throw new Error(
        'Required parameter destinationPath was null or undefined when calling blobUploadPost.'
      );
    }

    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });
    if (fileType !== undefined && fileType !== null) {
      queryParameters = queryParameters.set('FileType', <any>fileType);
    }
    if (destinationPath !== undefined && destinationPath !== null) {
      queryParameters = queryParameters.set(
        'DestinationPath',
        <any>destinationPath
      );
    }
    if (caseId !== undefined && caseId !== null) {
      queryParameters = queryParameters.set('CaseId', <any>caseId);
    }
    if (comments !== undefined && comments !== null) {
      queryParameters = queryParameters.set('Comments', <any>comments);
    }

    let headers = this.defaultHeaders;
    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }
    if (idToken !== undefined && idToken !== null) {
      headers = headers.set('Id-Token', String(idToken));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];

    headers = headers.set('Accept', httpHeaderAccepts);

    // to determine the Content-Type header
    const consumes: string[] = ['multipart/form-data'];

    const canConsumeForm = this.canConsumeForm(consumes);

    let formParams: { append(param: string, value: any): void };
    let useForm = false;
    let convertFormParamsToString = false;
    // use FormData to transmit files using content-type "multipart/form-data"
    // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
    useForm = canConsumeForm;
    if (useForm) {
      formParams = new FormData();
    } else {
      formParams = new HttpParams({
        encoder: new CustomHttpUrlEncodingCodec(),
      });
    }

    if (file !== undefined) {
      formParams = (formParams.append('File', <any>file) as any) || formParams;
    }

    return this.httpClient.request<number>(
      'post',
      `${this.basePath}/blob/upload`,
      {
        body: convertFormParamsToString ? formParams.toString() : formParams,
        params: queryParameters,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }
}
